module.exports = __webpack_public_path__ + "static/media/Chatot_gaussian2.9a86cb3d.png";